<template>
    <div class="go-back-arrow">
        <span @click="this.$router.back();">&larr;</span>
    </div>
</template>

<script>
    export default {
        name: "BackArrow",
        props: {
            visibleBack: {default: false},
        },
        methods: {
            goBack: function () {
                this.$router.back();
            }
        }
    }
</script>

<style scoped>
    .go-back-arrow {
        border: #2c3e50 solid 1px;
        border-radius: 5px;
    }
</style>